import main from "./scripts/main.js";
import objectFit from "./scripts/polyfills/objectFit.js";
import "@babel/polyfill";

// Polyfills
require("intersection-observer");
import "./scripts/polyfills/forEach";
import "./scripts/polyfills/includes";
import "./scripts/polyfills/customEvent";
import "./scripts/polyfills/scrollingElement";
import "./scripts/polyfills/prepend";
import "./scripts/polyfills/closest";

//
/* Polyfill service v3.25.1
 * For detailed credits and licence information see https://github.com/financial-times/polyfill-service.
 *
 * UA detected: chrome/79.0.0
 * Features requested: default
 *  */

(function(undefined) {
  /* No polyfills found for current settings */
}.call(
  ("object" === typeof window && window) ||
    ("object" === typeof self && self) ||
    ("object" === typeof global && global) ||
    {}
));

// Function to make IE9+ support forEach:
(function() {
  if (typeof NodeList.prototype.forEach === "function") return false;
  else NodeList.prototype.forEach = Array.prototype.forEach;
})();

// Create Element.remove() function if not exist
if (!("remove" in Element.prototype)) {
  Element.prototype.remove = function() {
    if (this.parentNode) {
      this.parentNode.removeChild(this);
    }
  };
}

objectFit.init(); // polyfill object-fit

/**
 * # Lancement des scripts
 */
main.init();
